import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useParams } from 'react-router-dom';
import HeaderV2 from '../components/HeaderV2';
import FooterV2 from '../components/FooterV2';
import StoreDetailPage from './StoreDetailPage';

/**
 * StoreDetailV2Page
 * 做法 A：殼換成 HeaderV2 + FooterV2，內容直接沿用舊版 StoreDetailPage。
 * 對應路由：/zh/store/:slug/v2、/en/store/:slug/v2
 * SEO：
 *   - /v2 預覽路由：noindex,follow + canonical 指回舊路由 /[lang]/store/:slug
 *   - 換骨後（無 /v2）：殼不輸出 robots/canonical，由內嵌 StoreDetailPage 自帶 SEO 接管
 */
export default function StoreDetailV2Page() {
  const location = useLocation();
  const { slug } = useParams<{ slug: string }>();
  const isEn = location.pathname.startsWith('/en');
  const lang = isEn ? 'en' : 'zh';
  const isPreviewRoute = location.pathname.includes('/v2');
  const canonicalUrl = `https://www.ongucoffee.com/${lang}/store/${slug ?? ''}`;

  useEffect(() => {
    // 注入 V2 字型（EB Garamond + Noto Serif TC）
    const fontId = 'v2-fonts-store-detail';
    if (!document.getElementById(fontId)) {
      const link = document.createElement('link');
      link.id = fontId;
      link.rel = 'stylesheet';
      link.href =
        'https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;1,400&family=Noto+Serif+TC:wght@300;400;500&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  return (
    <>
      {isPreviewRoute && (
        <Helmet>
          <meta name="robots" content="noindex,follow" />
          <link rel="canonical" href={canonicalUrl} />
        </Helmet>
      )}
      <div className="min-h-screen bg-white">
        <HeaderV2 />
        <StoreDetailPage />
        <FooterV2 />
      </div>
    </>
  );
}
